import { useNotifications } from "@/contexts/NotificationContext";
import { formatDistanceToNow } from "date-fns";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { CheckCheck, Volume2, VolumeX, TestTube2 } from "lucide-react";
import { api } from "@/lib/api";
import { toast } from "sonner";

export default function Notifications() {
  const { items, unread, markAllRead, markRead, soundEnabled, setSound } = useNotifications();

  const sendTest = async () => {
    try {
      await api.post("/notifications/test", { title: "Test notification", body: "This is a sample notification with sound." });
      toast.success("Test notification sent");
    } catch { toast.error("Failed"); }
  };

  return (
    <div className="space-y-6 max-w-4xl">
      <header className="flex items-end justify-between flex-wrap gap-4">
        <div>
          <div className="font-mono text-[10px] tracking-widest uppercase text-primary mb-2">// Inbox</div>
          <h1 className="font-display font-black text-4xl tracking-tighter">Notifications</h1>
          <p className="text-sm text-muted-foreground mt-1">{unread} unread — updated every 15s.</p>
        </div>
        <div className="flex items-center gap-2">
          <Button variant="outline" size="sm" onClick={() => setSound(!soundEnabled)} className="gap-2" data-testid="notif-sound-toggle">
            {soundEnabled ? <Volume2 className="h-3.5 w-3.5" /> : <VolumeX className="h-3.5 w-3.5" />}
            {soundEnabled ? "Sound on" : "Sound off"}
          </Button>
          <Button variant="outline" size="sm" onClick={sendTest} className="gap-2" data-testid="send-test-notif"><TestTube2 className="h-3.5 w-3.5" /> Send test</Button>
          <Button size="sm" onClick={markAllRead} className="gap-2" data-testid="mark-all-btn"><CheckCheck className="h-3.5 w-3.5" /> Mark all read</Button>
        </div>
      </header>

      {items.length === 0 ? (
        <div className="p-16 text-center rounded-lg border border-dashed border-border/60 text-sm text-muted-foreground">You're all caught up.</div>
      ) : (
        <div className="rounded-lg border border-border/60 bg-card divide-y divide-border/40">
          {items.map((n) => (
            <Link
              key={n.notification_id}
              to={n.link || "#"}
              onClick={() => !n.read && markRead(n.notification_id)}
              className={`flex items-start gap-3 p-4 hover:bg-secondary/40 transition-colors ${!n.read ? "bg-primary/5" : ""}`}
              data-testid={`notif-page-item-${n.notification_id}`}
            >
              <span className={`mt-1.5 h-2 w-2 rounded-full ${!n.read ? "bg-primary" : "bg-transparent"}`} />
              <div className="flex-1">
                <div className="flex items-baseline gap-2">
                  <span className="font-medium text-sm">{n.title}</span>
                  <span className="font-mono text-[10px] uppercase tracking-widest text-muted-foreground">{n.kind.replace(/_/g," ")}</span>
                </div>
                <div className="text-sm text-muted-foreground">{n.body}</div>
              </div>
              <span className="font-mono text-[10px] text-muted-foreground shrink-0">{formatDistanceToNow(new Date(n.created_at), { addSuffix: true })}</span>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
